import dw from 'web-digital-watermarking'
import fb from 'firebase/app'
import IPFS from 'ipfs-core'
import QR from 'qrcode'
import QuickEncrypt from 'quick-encrypt'
import secrets from 'secrets.js-34r7h'
import Vue from 'vue'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'

import s from './state'
import m from './mutations'

const ipf = IPFS.create()
const t = true;

var config = {
  apiKey: 'AIzaSyCkBtZocdLODH_oV-MSRRGVYpvLkiR2cFY',
  authDomain: 'itsli7-87384.firebaseapp.com',
  databaseURL: 'https://itsli7-87384.firebaseio.com',
  projectId: 'itsli7-87384',
  storageBucket: 'itsli7-87384.appspot.com',
  messagingSenderId: '503897448704'
}
fb.initializeApp(config)
var storage = fb.storage()
var version = '1'
const fbBase = fb.firestore().collection(encodeURIComponent(window.location.hostname)).doc('v' + version)
const fbBaseConfig = fb.firestore().collection('config').doc('defaults')
const fbusersbase = fb.firestore().collection('users').doc('v' + version)
const fbBaseUsers = fb.firestore().collection('state').doc('users')
const fbBaseLex = fb.firestore().collection('lexicon')
const fbBaseState = fb.firestore().collection('state')
const fbBaseTokens = fb.firestore().collection('tokens')
// const fbBaseSchedule = fb.firestore().collection('schedule').doc(encodeURIComponent(window.location.hostname))


const util = {
    fb(){
      return {fb, fbBase, fbBaseConfig, fbusersbase, fbBaseUsers, fbBaseLex, fbBaseState, fbBaseTokens, storage}
    },
    findcurrentfunction(id) {
      if (typeof s.app.advanced.functions[id] !== 'string') {
        return s.app.advanced.functions[id]
      } else {
        return util.findcurrentfunction(s.app.advanced.functions[s.app.advanced.functions[id]])
      }
    },
    convert(value, base) {
      // converts a value to a base
      // https://www.npmjs.com/package/base64url
      let from = ''
      if (typeof value === 'string') {
        from = value[0] === '.' ? 'hex' : value[0] === '~' ? 'base64url' : 'unknown'
        if (from !== 'unknown') value = value.slice(1, -1)
        console.log(value, from);
      }
      const conversions = {
        hex: x => x,
        base64url: x => x,
        unknown: x => x,
      }
      return conversions[from](value, base)
    },
    async ipfs(obj) {
      return ipf.then(async d => {
        return await d.add(obj)
      })
    },
    async encrypt(sensitiveInfo, publicKey) {
      m.log(sensitiveInfo, publicKey)
      let encrypted = await QuickEncrypt.encrypt(JSON.stringify(sensitiveInfo), publicKey)
      return encrypted
    },
    strToNum(str) {
      if (s.debug) m.log('strToNum()', str)
      var charCodeArr = []
      str.split('').forEach((letter) => {
        charCodeArr.push(letter.charCodeAt(0))
      })
      var commaArr = []
      var commaLocation = 0
      // 2. Keep track of comma locations after turning the array into a string
      charCodeArr.forEach((char) => {
        commaLocation = commaLocation + char.toString().length
        commaArr.push(Number(commaLocation))
      })
      var decommaStr = util.strReplace(charCodeArr.toString(), ',', '')
      m.setState(s, { prop: 'map', val: commaArr })
      return decommaStr
    },
    numToStr(num, map) {
      if (s.debug) m.log('numToStr()', arguments)
      // var numArr = num.split('')
      map.forEach((commaPlace) => {
        console.warn(num.split(commaPlace))
      })
    },
    async crypto(type, payload, key) {
      if (type === 'hash') {
        return (() => {
          let objsort = (obj) => Object.fromEntries(Object.entries(obj).sort())
          const msgUint8 = new TextEncoder().encode(JSON.stringify(objsort(payload)));
          const hashBuffer = crypto.subtle.digest('SHA-256', msgUint8);           // hash the message
          const hashArray = Array.from(new Uint8Array(hashBuffer));                     // convert buffer to byte array
          const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
          return hashHex;
        })()

      }
      if (s.debug) m.log('crypto()', payload)
      if (type === 'createKey') {
        return window.crypto.subtle.generateKey(
          { name: 'AES-CTR', length: 256 }, // can be  128, 192, or 256
          t, // whether the key is extractable (i.e. can be used in exportKey)
          ['encrypt', 'decrypt', 'wrapKey', 'unwrapKey'] // can 'encrypt', 'decrypt', 'wrapKey', or 'unwrapKey'
        ).then(function (key) {
          // returns a key object
          return window.crypto.subtle.exportKey(
            'jwk', // can be 'jwk' or 'raw'
            key // extractable must be t
          ).then(function (keydata) {
            // returns the exported key data
            console.log(keydata, keydata.k)
            return key
          }).catch(function (err) {
            console.error(err)
          })
        })
          .catch(function (err) {
            console.error(err)
          })
      }
      if (type === 'encrypt') {
        window.crypto.subtle.generateKey({ name: 'AES-CTR', length: 256 }, t, ['encrypt', 'decrypt']).then(function (key) {
          return window.crypto.subtle.exportKey('jwk', key).then(function () {
            // returns the exported key data
            window.crypto.subtle.encrypt({ name: 'AES-CTR', counter: new Uint8Array(16), length: 128 }, key, Buffer.from(JSON.stringify(payload))).then(function (encrypted) {
              // returns an ArrayBuffer containing the encrypted data
              var wb = fb.firestore().batch()
              wb.set(fbBase.collection('secure').doc(payload.salt.toString()), {
                bytes: JSON.stringify(new Uint8Array(encrypted))
              }).commit()
              util.crypto('decrypt', { id: payload.id }, key)
              return new Uint8Array(encrypted)
            }).catch(err => console.error(err))
          }).catch((err) => console.error(err))
        })
      }
      if (type === 'decrypt') {
        fbBase.collection('secure').doc(encodeURIComponent(payload.id + ' ' + s.auth.uid)).get().then((data) => {
          let uint8 = []
          Object.keys(JSON.parse(data.data().bytes)).forEach((iter) => {
            uint8.push(JSON.parse(data.data().bytes)[iter])
          })
          let encryptedBytes = new Uint8Array(uint8)
          window.crypto.subtle.decrypt({ name: 'AES-CTR', counter: new Uint8Array(16), length: 128 }, key, encryptedBytes).then((decrypted) => {
            let decryptString = String.fromCharCode.apply(null, new Uint8Array(decrypted))
            return decryptString
          })
        })
      }
      if (type === 'secret') {
        return {
          key(bits) {
            bits = !bits || isNaN(bits) || bits < 1 ? 512 : bits
            return secrets.random(bits)
          },
          share(key, shares, thresh) {
            return secrets.share(key, +shares, +thresh)
          },
          combine(shares) {
            return secrets.combine(shares)
          },
          newshare(id, shares) {
            return secrets.newShare(id, shares)
          },
          hex2str(hex) {
            return secrets.hex2str(hex)
          },
          str2hex(str) {
            return secrets.str2hex(str)
          },
        }
      }
      // if (type === 'sign') { }
      // if (type === 'importKey') { }
      // if (type === 'exportKey') { }
    },
    qr(obj) {
      return QR.toDataURL(obj)
    },
    strReplace(target, search, replacement) {
      if (s.debug) m.log('strReplace()', arguments)
      return target.replace(new RegExp(search, 'g'), replacement)
    },
    async decodewm(enCodeImageUrl, id) {
      const response = await fetch(enCodeImageUrl)
      const imageBlob = await response.blob()
      const reader = new FileReader();
      reader.readAsDataURL(imageBlob);
      reader.onloadend = async () => {
        const base64data = reader.result;
        return await dw.getTextFormImageUrl(base64data).then(x => {
          console.log({ x })
          return Vue.set(s.decoded, id, x)
        });
      }
    }
  }

  export default util